declare namespace $ {

	export class $mol_icon_music extends $mol_icon {
		path( ): string
	}
	
}

//# sourceMappingURL=music.view.tree.d.ts.map